import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=269f03b6&scoped=true"
import script from "./Splitter.vue?vue&type=script&lang=ts"
export * from "./Splitter.vue?vue&type=script&lang=ts"
import style0 from "./Splitter.vue?vue&type=style&index=0&id=269f03b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f03b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269f03b6')) {
      api.createRecord('269f03b6', component.options)
    } else {
      api.reload('269f03b6', component.options)
    }
    module.hot.accept("./Splitter.vue?vue&type=template&id=269f03b6&scoped=true", function () {
      api.rerender('269f03b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Splitter.vue"
export default component.exports